"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "visningsdefinisjonKonstanter", {
    enumerable: true,
    get: function() {
        return visningsdefinisjonKonstanter;
    }
});
var _skattemeldingconstants = /*#__PURE__*/ _interop_require_default(require("./visningsdefinisjon/v2/2024/skattemelding/skattemelding.constants"));
var _skattemeldingconstants1 = /*#__PURE__*/ _interop_require_default(require("./visningsdefinisjon/v2/2023/skattemelding/skattemelding.constants"));
var _skattemeldingconstants2 = /*#__PURE__*/ _interop_require_default(require("./visningsdefinisjon/v2/2022/skattemelding/skattemelding.constants"));
var _skattemeldingconstants3 = /*#__PURE__*/ _interop_require_default(require("./visningsdefinisjon/v2/2021/skattemelding/skattemelding.constants"));
var _naeringconstants = /*#__PURE__*/ _interop_require_default(require("./visningsdefinisjon/v2/2024/naering/naering.constants"));
var _naeringconstants1 = /*#__PURE__*/ _interop_require_default(require("./visningsdefinisjon/v2/2023/naering/naering.constants"));
var _naeringconstants2 = /*#__PURE__*/ _interop_require_default(require("./visningsdefinisjon/v2/2022/naering/naering.constants"));
var _naeringconstants3 = /*#__PURE__*/ _interop_require_default(require("./visningsdefinisjon/v2/2021/naering/naering.constants"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var visningsdefinisjonKonstanter = {
    "2021": {
        skattemelding: _skattemeldingconstants3.default,
        naering: _naeringconstants3.default
    },
    "2022": {
        skattemelding: _skattemeldingconstants2.default,
        naering: _naeringconstants2.default
    },
    "2023": {
        skattemelding: _skattemeldingconstants1.default,
        naering: _naeringconstants1.default
    },
    "2024": {
        skattemelding: _skattemeldingconstants.default,
        naering: _naeringconstants.default
    }
};
